import React from 'react';
import { Link } from 'react-router-dom';

import { SignUpServiceProviderForm } from 'features/authentication';

import { defaultMetaTags } from 'default-meta';
import { createPage } from 'libs/ssr/createPage';
import { MetaTags } from 'libs/metaTags';

import s from './provider-sign-up.module.css';

function SignUpProviderPage() {
  return (
    <>
      <MetaTags {...metaTags} />

      <div className={s.wrapper}>
        <div className={s.logoSide}>
          <div className={s.logo} />
        </div>
        <div className={s.mainSide}>
          <div className={s.header}>
            <Link className={s.backLink} to="/" />
            <Link className={s.loginLink} to="/login">
              Sign in
            </Link>
          </div>
          <div className={s.body}>
            <h1 className={s.title}>Sign Up as Provider</h1>
            <Link className={s.sign} to="/sign-up-pet-owner">
              Sign up as Pet Owner →
            </Link>
            <SignUpServiceProviderForm />
          </div>
        </div>
      </div>
    </>
  );
}

const metaTags = {
  ...defaultMetaTags,
  title: 'Pawzr For Business | Pawzr',
};

export default createPage(SignUpProviderPage, {
  renderMetaTags: (url, _, host) => <MetaTags {...metaTags} url={url} />,
});
